//imports
import {
    PM_USERS_CREATE_USER_REQUEST,
    PM_USERS_CREATE_USER_RESULT,
    PM_USERS_UPDATE_USER_REQUEST,
    PM_USERS_UPDATE_USER_RESULT,
    PM_USERS_SEARCH_ROLES_REQUEST,
    PM_USERS_SEARCH_ROLES_RESULT,
    PM_USERS_CREATE_USER_OPEN_MODAL,
    PM_USERS_CREATE_USER_CLOSE_MODAL,
    PM_USERS_GET_USER_REQUEST,
    PM_USERS_GET_USER_RESULT,
} from 'Redux/actionTypes';

export const pmUsersGetUserRequest = (id) => ({
    type: PM_USERS_GET_USER_REQUEST,
    payload: id
});

export const pmUsersGetUserResult = (result) => ({
    type: PM_USERS_GET_USER_RESULT,
    payload: result,
});

export const createPMUserOpenModal = (id) => ({
    type: PM_USERS_CREATE_USER_OPEN_MODAL,
    payload: { id },
});

export const createPMUserCloseModal = () => ({
    type: PM_USERS_CREATE_USER_CLOSE_MODAL
});

export const createPMUserRequest = (data) => ({
    type: PM_USERS_CREATE_USER_REQUEST,
    payload: data,
});

export const createPMUserResult = (result) => ({
    type: PM_USERS_CREATE_USER_RESULT,
    payload: result
});

export const updatePMUserRequest = (data) => ({
    type: PM_USERS_UPDATE_USER_REQUEST,
    payload: data
});

export const updatePMUserResult = (result) => ({
    type: PM_USERS_UPDATE_USER_RESULT,
    payload: result
});

export const usersSearchRolesRequest = () => ({
    type: PM_USERS_SEARCH_ROLES_REQUEST,
});

export const usersSearchRolesResult = (result) => ({
    type: PM_USERS_SEARCH_ROLES_RESULT,
    payload: result
});